module.exports = __webpack_public_path__ + "img/thoughtworks.7b7bbab8.png";